import * as Yup from "yup";

export const CompanyAccountSchema = Yup.object().shape({
    name: Yup.string().default(""),
    registryCode: Yup.string().default(""),
    countryCode: Yup.string().default(""),
    vatNumber: Yup.string().default(""),
});
